import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {Nav, NavItem} from "./nav.model";



// Models in used:


// let navs:{
//     "footer01": Nav;
// };

@Component( {
  selector: 'app-nav, [app-nav]',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  encapsulation: ViewEncapsulation.None
} )
export class NavComponent implements OnInit {

    @Input() navData:Nav;
    @Input() navType: string = "navbar"; // navbar, sidebar
    @Input() navStyle: string = ""; // myacc-dash, footer, header
    @Input() isMobile:boolean =  false; // true, false //change to is mobile
    @Input() titleOn:boolean = true; // true, false
    @Input() actionsOn :boolean = true; // true, false
    @Output() componentAction:EventEmitter<string> = new EventEmitter<string>();

    nav:NavItem[];
    title:string = "";
    visible = {
        title: false,
        subNav: false
    };

  constructor() { }

  ngOnInit() { }

  getClass(){
    return this.navType + " " + this.navStyle;
  }

  actions( event ){
      console.log("NavComponent actions() event", event);
     this.componentAction.next(event);
  }
  orederNav( items: NavItem[] ){
      if (items.length > 0 ){
          return items.sort((a, b) => {return a.order - b.order});
      }
  }
    /** TODO:
     *
     * Types:
     * - solid bar with dropdown 3 levels
     * - horizontal tree
     * - is mobile collapsible click if vs is mobile false (desktop mode) hover.
     *
     * notes: https://www.w3schools.com/Css/css_navbar.asp - position: sticky; -
     *
     */

}





